import { createAsyncThunk } from '@reduxjs/toolkit'
import { PaymentResponse, PaymentSource } from 'redux/types'
import railsApiService from 'services/api/rails-api-service'

interface ConsultationCheckoutParams {
  order_number?: string
  payment_source: Record<number, PaymentSource>
  order: {
    payments_attributes: {
      payment_method_id: number
      installments?: string
    }[]
  }
  iugu_card_id?: string
  is_free?: boolean
}

export const consultationCheckout = createAsyncThunk(
  'consultation-checkout',
  async ({ order_number, ...params }: ConsultationCheckoutParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.put<PaymentResponse>(`/api/v1/checkouts/${order_number}`, {
        ...params
      })

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
